import React from 'react';

const HowItWorks: React.FC = () => {
  return (
    <section className="px-5 pt-12 pb-20 bg-black" id="how-it-works">
      <div className="max-w-[1306px] w-full mx-auto">
        <h2 className="font-semibold text-[30px] md:text-[36px] text-center text-white mb-16">
          How It Works
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-16 md:gap-10">
          {[
            {
              title: 'Create Your \n Free Account',
              img: 'https://gearfocus.b-cdn.net/landings/create-free-account.png',
              alt: 'Create Your Free Account',
            },
            {
              title: 'List or Buy \n Instantly',
              img: 'https://gearfocus.b-cdn.net/landings/list-buy-instantly.png',
              alt: 'List or Buy Instantly',
            },
            {
              title: 'Verified, Trustworthy \n Sellers Only',
              img: 'https://gearfocus.b-cdn.net/landings/verified-trustworthy-sellers.png',
              alt: 'Verified, Trustworthy Sellers Only',
            },
            {
              title: '48-Hour Buyer \n Verification (Risk-Free)',
              img: 'https://gearfocus.b-cdn.net/landings/48-hour-buyer-verification.png',
              alt: '48-Hour Buyer Verification',
            },
            {
              title: 'Insured Shipping, \n Fast Payouts',
              img: 'https://gearfocus.b-cdn.net/landings/insured-shipping-fast-payouts.png',
              alt: 'Insured Shipping, Fast Payouts',
            },
          ].map((step, index) => (
            <div key={index} className="flex flex-col items-center gap-10">
              <p className="text-[20px] font-medium text-white text-center whitespace-pre-line">
                {step.title}
              </p>
              <img src={step.img} alt={step.alt} loading="lazy" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
